module.exports = __webpack_public_path__ + "img/mg-abc.6024125a.png";